<template>
    <div class="model_service_box companyInfo companyInfoNew" @click="clickDocument">
        <div class="model_service_container campanyService" v-show="isShow" :style="openPage=='company_extend'?'width:800px;padding-bottom:0px;':''">
            <div class="pc-title modeling_title">

                <!-- 改 -->
                <span v-show="openPage!='company_extend'" class="pc-head modeling_head" :class="vclass?vclass+'_border':''">{{alertTitle}}</span>
                <span  v-show="openPage!='company_extend'" style="margin-left:-10px;">{{titleTip}}<span v-if="showStep">（ {{step}} / {{stepALL}} ）</span></span>
                <span v-show="openPage=='company_extend'" class="pc-head modeling_head" :class="vclass?vclass+'_border':''">请选择您感兴趣的领域</span>
                <!-- <span style="margin-left:-10px;">{{titleTip}}<span v-if="showStep">（ {{step}} / {{stepALL}} ）</span></span> -->
                <span class="layui-layer-setwin close_btn" @click="hidePanel"><a class="layui-layer-ico layui-layer-close layui-layer-close1" href="javascript:;"></a></span>
            </div>
            <div class="modeling_content" v-show="openPage=='phone'">
                <div class="form_item" style="height:25px;">
                    <div class="label_item" style="padding-top:3px;">昵称 (登录专用)<span class="must_item">*</span></div>
                    <div class="content_item">
                         <div class="input_item campanyInfo" style="border:none;height:25px;">
                             <div style="line-height:25px;">{{userNick}}</div>
                         </div>
                    </div>
                </div>
                <div class="form_item" >
                    <div class="label_item">手机号<span class="must_item">*</span></div>
                    <div class="content_item">
                         <div class="input_item campanyInfo" :class="(phoneNumber!='' && !phoneNumberOk)?'error-box':''">
                             <input class="perPhone" type="text" placeholder="请输入手机号" v-model="phoneNumber" @blur="checkPhone()">
                         </div>
                    </div>
                     <div class="checkBox">
                       <span v-show="phoneNumber!='' && phoneNumberOk" class="icon iconfont icon-duigoutianchong-"></span>
                       <span v-show="phoneNumber!='' && !phoneNumberOk" class="icon iconfont icon-cuowu2" title="手机号格式错误或已绑定"></span>
                    </div>
                </div>
                <div class="form_item" >
                    <div class="label_item">验证码<span class="must_item">*</span></div>
                    <div class="content_item" >
                         <div class="input_item campanyInfo" style="display:flex;">
                            <input class="perPhoneCode" type="text" placeholder="请输入验证码" style="width:60%;" v-model="phoneCode">
                            <div class="send_code send_code_phone" v-show="!sending" :class="{no_send1:sendState}" @click="sendCode()">发送验证码</div>
                            <div class="send_code send_code_phone no_send1" v-show="sending">{{time}}s后重新获取</div>
                         </div>
                    </div>
                </div>
                <!-- <div class="form_item" >
                    <div class="label_item">推荐人<span class="must_item"></span></div>
                    <div class="content_item" >
                         <div class="input_item campanyInfo" style="display:flex;">
                            <input class="perPhoneCode" type="text" placeholder="请输入推荐人" maxlength="12" v-model="referee">
                         </div>
                    </div>
                </div> -->
                <div class="form_item make_order">
                    <div class="label_item"></div>
                    <div class="content_item">
                        <div class="submit" :class="vclass" @click="bindPhone()" v-if="stepALL!==1">下一步</div>
                        <div class="submit" :class="vclass" @click="bindPhone()" v-if="stepALL==1">提交</div>
                        <!-- stepNext -->
                    </div>
                </div>
            </div>
            <div class="modeling_content" v-show="openPage=='info'">
                <div class="form_item" style="height:25px;">
                    <div class="label_item" style="padding-top:3px;">昵称 (登录专用)<span class="must_item">*</span></div>
                    <div class="content_item">
                         <div class="input_item campanyInfo" style="border:none;height:25px;">
                             <div style="line-height:25px;">{{userNick}}</div>
                         </div>
                    </div>
                </div>
                <div class="form_item" ref = "showCompanyPanel" @click="hideCompanyDiv($event)">
                    <div class="label_item">单位<span class="must_item">*</span></div>
                    <div class="content_item"  style="position:relative;">
                         <div class="input_item campanyInfo campanynameInput" :class="isflagShow==3?'error-box':''">
                             <!-- @input="checkCampanyName2" @blur="checkCampanyName2()" @keydown="cleatInter()" @keyup="startInter()" -->
                            <input type="text" placeholder="请输入单位名称" id="companyRec" v-model="camName" @blur="checkCampanyName();" @click="getCurrentCompany(camName,$event)"  @input="getCurrentCompany(camName,$event)" @keydown.tab="getCurrentCompany(camName,$event)" autocomplete="off" tabindex="-1">
                            <span v-if="camName.length" class="layui-layer-setwin close_btn" style="padding:3px;top:7px;right:3px;border-radius: 50%;background:rgb(0,0,0 , 0.34);opacity:0.5" @click="clearCompany($event)"><a href="javascript:;" style="margin:0;transform: scale(0.8);background-position: 2px -39px;" class="layui-layer-ico layui-layer-close layui-layer-close1"></a></span>
                         </div>
                    </div>
                    <div class="checkBox">
                        <span v-show="isflagShow==1" class="icon iconfont icon-duigoutianchong-"></span>
                        <span v-show="isflagShow==2" class="icon iconfont icon-iconfontwenhao1" style="color:rgb(245, 180, 38);font-sieze:19px;" title="单位信息待验证"></span>
                        <span v-show="isflagShow==3" class="icon iconfont icon-cuowu2" title="单位不允许包含数字"></span>
                    </div>
                    <div class="company-bg" v-show="companyBgShow">
                        <ul class="company-list">
                            <li v-for="(item,index) in companyNameList" v-if="companyNameList.length"  :key="item.id" :class="companyCurrentIndex-1==index?'active':''" @click="companyKey(item,index,$event)">
                                <span v-html="$options.filters.hightStr(item.companyName,originCamName||camName)" @click="companyKey(item,index,$event)"></span>
                            </li>

                        </ul>
                    </div>
                </div>
                <!-- 进页面显示 -->
                <div class='comCheckTip' v-show=" !this.isflagShow || this.isflagShow!==3">
                    请填写单位全称。首次通过单位名认证可奖励500魔豆！
                </div>
                <!-- 验证不通过，显示 -->
                <div class='errorCheckTip' v-show="this.isflagShow==3">
                    单位名认证未通过！首次通过单位名认证可奖励500魔豆！
                </div>
                <ul class="matchCompany" v-show="matchCom">
                    <li v-for="(item) in matchList" v-bind:key="item.name" @click="selectCompany">{{item.name}}</li>
                </ul>
                <div class="form_item" >
                    <div class="label_item">姓名<span class="must_item">*</span></div>
                    <div class="content_item">
                         <div class="input_item campanyInfo" :class="isPerName==2?'error-box':''">
                             <input type="text" placeholder="请输入姓名" v-model="perName" @blur="checkName()" tabindex="-1">
                         </div>
                    </div>
                     <div class="checkBox">
                       <span v-show="isPerName == 1" class="icon iconfont icon-duigoutianchong-"></span>
                       <span v-show="isPerName == 2" class="icon iconfont icon-cuowu2" title="姓名至少为2个字符，且不包含数字"></span>
                    </div>
                </div>
                <div class="form_item" ref = "showPanel" @click="hideDiv($event)">
                    <div class="label_item">职务<span class="must_item">*</span></div>
                    <div class="content_item">
                         <div class="input_item campanyInfo" :class="isJobName==2?'error-box':''" :style = "{borderTopColor:(workShow ? '#e8e8e8' : '')}">
                            <input type="text" placeholder="请填写或选择职务" v-model="perJob" tabindex="-1" id="text" autocomplete="off" @click= "getCurrent(perJob,$event);" @keyup="getCurrent(perJob,$event);" @keyup.enter="hideDiv()" @keydown.tab="hideDiv()">
                            <span v-if="perJob.length" class="layui-layer-setwin close_btn" style="padding:3px;top:7px;right:3px;border-radius: 50%;background:rgb(0,0,0 , 0.34);opacity:0.5" @click="clearJob($event)"><a href="javascript:;" style="margin:0;transform: scale(0.8);background-position: 2px -39px;" class="layui-layer-ico layui-layer-close layui-layer-close1"></a></span>
                            <!-- <div class = "triangle-icon" ></div> -->
                         </div>
                    </div>
                     <div class="checkBox">
                       <span v-show="isJobName == 1" class="icon iconfont icon-duigoutianchong-"></span>
                       <span v-show="isJobName == 2" class="icon iconfont icon-cuowu2" title="职务至少为2个字符，且不包含数字"></span>
                    </div>
                    <div class = "work_bg" v-if = "workShow">
                        <div class = "work-us" >
                                <div class="industrySelection">
                                    <p>请选择您的职务</p>
                                    <span class="layui-layer-setwin close_btn close_selection" @click="hideDiv()"><a href="javascript:;" class="layui-layer-ico layui-layer-close layui-layer-close1"></a></span>
                                </div>

                            <div class = "work-list">
                                <ul class="firstli-scroll" v-if="!perJob.length&&!findShow">
                                    <li v-for = "(item,index) in searchResult" :key = 'index' :data-order="item.order" @click="showindexlist(index)">
                                        <span>{{item.name}}</span>
                                        <ul class="secondli-scroll" v-if="item.total">
                                            <!-- <li><span>{{item.name}}</span></li> -->
                                            <li v-for="(val,i) in item.children">
                                                <span >{{val.name}}</span>
                                                <ul class="lasrtli-scroll" v-if="val.total">
                                                    <li v-for="(value,ind) in val.children">
                                                        <span @click = "workKey(value,index,$event)">{{value.name}}</span>
                                                    </li>
                                                </ul>
                                            </li>
                                        </ul>
                                    </li>
                                </ul>
                                <ul class="search-firstli-scroll" v-if="perJob.length&&findShow">
                                    <li v-for="(value,ind) in searchResultJob" v-if="searchResultJob.length" :class="currentIndex-1==ind?'active':''">
                                        <span v-html="$options.filters.hightStr(value.name,originPerJob||perJob)" @click = "workKey(value,index,$event)"></span>
                                    </li>
                                    <li v-if="!searchResultJob.length" class="findnone">暂无匹配结果</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="form_item make_order">
                    <div class="label_item"></div>
                    <div class="content_item">
                        <div class="submit" :class="vclass" @click="makeOrder()" v-if="stepALL==1">提交</div>
                        <div class="submit" :class="vclass" @click="makeOrder()" v-if="stepALL>1">下一步</div>
                    </div>
                </div>
            </div>
            <div class="modeling_content" v-show="openPage=='company_extend'" style="padding-top:0px;" >
                 <!-- <div class="firstline" >请选择您感兴趣的领域，我们会根据您的选择提供更丰富的内容</div> -->
                 <div class="form_item code_style" >
                    <div class="category" style="width:65px;">开发形式</div>
                    <input type="checkbox" id="lowcode" name="code" value="低代码数字孪生" checked v-model="checkCode">
                    <div class="label_box" ><label class="low " for="lowcode" @click="choose( 'lowcode')">低代码数字孪生</label></div>
                    <input type="checkbox" id="zerocode" name="code" value="零代码数字孪生" v-model="checkCode">
                    <div class="label_box"><label class="zero" for="zerocode" @click="choose('zerocode')">零代码数字孪生</label></div>
                </div>
                <div class="form_item code_style top" >
                    <div class="category" >智慧场景</div>
                    <div class="right_box">
                    <input type="checkbox" id="city" name="scene" value="智慧城市" checked v-model="checkScene">
                    <div class="label_box" ><label class="city " for="city" @click="choosescene('city')" >智慧城市</label></div>
                    <input type="checkbox" id="camp" name="scene" value="智慧园区" v-model="checkScene">
                    <div class="label_box"><label class="camp" for="camp" @click="choosescene('camp')">智慧园区</label></div>
                    <input type="checkbox" id="community" name="scene" value="智慧社区" v-model="checkScene">
                    <div class="label_box" ><label class="community" for="community" @click="choosescene('community')" >智慧社区</label></div>
                    <input type="checkbox" id="factory" name="scene" value="智慧工厂" v-model="checkScene">
                    <div class="label_box"><label class="factory" for="factory" @click="choosescene('factory')">智慧工厂</label></div>
                    <div class="kong"></div>
                    <input type="checkbox" id="school" name="scene" value="智慧校园" v-model="checkScene">
                    <div class="label_box" ><label class="school" for="school" @click="choosescene('school')" >智慧校园</label></div>
                    <input type="checkbox" id="medica" name="scene" value="智慧医疗" v-model="checkScene">
                    <div class="label_box"><label class="medica" for="medica" @click="choosescene('medica')">智慧医疗</label></div>
                    <input type="checkbox" id="water" name="scene" value="智慧水利" v-model="checkScene">
                    <div class="label_box" ><label class="water" for="water" @click="choosescene('water')" >智慧水利</label></div>
                    <input type="checkbox" id="traffic" name="scene" value="智慧交通" v-model="checkScene">
                    <div class="label_box"><label class="traffic" for="traffic" @click="choosescene('traffic')">智慧交通</label></div>
                    </div>
                </div>
                <div class="form_item code_style top">
                    <div class="category" >意向产品</div>
                    <div class="right_box">
                    <input type="checkbox" id="visualization" name="product" value="数据可视化" checked v-model="checkProduct" >
                    <div class="label_box" ><label class="visualization " for="visualization" @click="chooseproduct('visualization')" >数据可视化</label></div>
                    <input type="checkbox" id="Web" name="product" value="Web组态" v-model="checkProduct">
                    <div class="label_box"><label class="Web" for="Web" @click="chooseproduct('Web')">Web组态</label></div>
                    <input type="checkbox" id="threecity" name="product" value="三维城市" v-model="checkProduct">
                    <div class="label_box" ><label class="threecity" for="threecity" @click="chooseproduct('threecity',value)" >三维城市</label></div>
                    <input type="checkbox" id="threecamps" name="product" value="三维园区" v-model="checkProduct">
                    <div class="label_box"><label class="threecamps" for="threecamps" @click="chooseproduct('threecamps')">三维园区</label></div>
                    <input type="checkbox" id="integration" name="product" value="数据集成" v-model="checkProduct">
                    <div class="label_box" style="margin-right:0px;"  ><label class="integration" for="integration" @click="chooseproduct('integration')" >数据集成</label></div>
                    </div>
                </div>
                <div class="form_item code_style top">
                    <div class="category" style="margin-top:5px;margin-right:10px;"  >更多需求</div>
                    <input class="moreneeds" type="text" autocomplete="off" v-model="moreneeds"  placeholder="请告诉我们您感兴趣的领域">
                    <input type="text">
                </div>
                <div class="selected" >
                    <div class="form_item code_style top" style="padding-top: 10px;">
                        <div class="category selectedText" style="margin-top:3px;margin-right:10px;"  >已选择：</div>
                        <div class="selectedBox" ></div>
                        <div class="cancle" >
                        </div>
                    </div>
                </div>
                <div class="nextbutton">
                    <div class="button" @click="nextStep()" >下一步</div>
                    <div class="nevernotify" >
                        <div class="never" >
                            <div class="checkBoxLast" @click="checkNever()" ></div>
                            <div class="textTips" >不再显示</div>
                        </div>
                    </div>
                </div>

            </div>
            <div class="modeling_content" v-show="openPage=='setPwd'">
                <div class="form_item">
                    <div class="label_item">昵称 (登录专用)<span class="must_item">*</span></div>
                   <div class="content_item">
                        <div class="input_item campanyInfo" :class="userNicktip?'error-box':''">
                            <input class="userNick" type="text" placeholder="请输入昵称" v-model="userNick" @blur="checkUserNick()">
                        </div>
                    </div>
                    <div class="checkBox">
                       <span v-show="userNicktip" class="icon iconfont icon-cuowu2" title="昵称不允许为空"></span>
                    </div>
                </div>
                <div class="comCheckTip">* 昵称为登录专用，为方便您的使用，请修改昵称</div>
                <div class="form_item" >
                    <div class="label_item">密码<span class="must_item">*</span></div>
                    <div class="content_item">
                        <div class="input_item campanyInfo" :class="pwdOldtip?'error-box':''">
                            <input class="pwdOld" type="password" placeholder="请输入密码" v-model="pwdOld" @blur="checkPwd()">
                        </div>
                    </div>
                    <div class="checkBox">
                       <span v-show="pwdOldtip" class="icon iconfont icon-cuowu2" title="密码格式错误" ></span>
                    </div>
                </div>
                <div class="form_item" >
                    <div class="label_item">确认密码<span class="must_item">*</span></div>
                    <div class="content_item">
                         <div class="input_item campanyInfo" :class="pwdAgaintip?'error-box':''">
                             <input class="pwdAgain" type="password" placeholder="请再次输入密码" v-model="pwdAgain" @blur="checkPwd('again')">
                         </div>
                    </div>
                     <div class="checkBox">
                       <span v-show="pwdAgaintip" class="icon iconfont icon-cuowu2" title="两次输入密码不一致"></span>
                    </div>
                </div>
                <div class="form_item make_order">
                    <div class="label_item"></div>
                    <div class="content_item">
                        <div class="submit" @click="setPwd()">提交</div>
                    </div>
                </div>
            </div>
            <div class="model_service_box" v-show="orderSuccess">
                <div class="order_success_container">
                    <div class="order_success_title" >
                        <span class="pc-head">提示</span>
                        <span class="layui-layer-setwin"  @click="closeSuccessBox()"><a class="layui-layer-ico layui-layer-close layui-layer-close1" href="javascript:;"></a></span>
                    </div>
                    <div class="order_seccess_content">提交成功。感谢您的配合！</div>
                    <div class="footer_box" >
                        <Button id="submitOK" style="top: -1px;position: relative;"  @click="showTool()">确定</Button>
                    </div>
                </div>
            </div>
            <div class="model_service_box" v-show="orderError">
                <div class="order_success_container">
                    <div class="order_success_title" >
                        <span class="pc-head"> 提示</span>
                        <span class="layui-layer-setwin"  @click="closeErrorBox()"><a class="layui-layer-ico layui-layer-close layui-layer-close1" href="javascript:;"></a></span>
                    </div>
                    <div class="order_seccess_content">{{orderError}}</div>
                    <div class="footer_box" >
                        <Button style="top: -1px;position: relative;"  @click="closeErrorBox()">关闭</Button>
                    </div>
                </div>
            </div>
            <div  class="model_service_box loading_box" v-show="loading && openPage!='company_extend'">
                <Button loading shape="circle" type="primary" style="background:#ff6110;border-color: #ff6110;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);">信息验证中...</Button>
            </div>
        </div>
        <div class="model_service_box success_box" v-show='showPanel'>
            <div id="dialogSucc" class="sureAlert" v-show="showPanel" style="height:auto;">
                <div class="title move">
                    <p class="title-p">{{panelTitle}}</p>
                    <span class="close_c"  @click="closeInfoPanel()">
                        <i class="iconfont icon-close"></i>
                    </span>
                </div>
                <div class="sureContent" style="display:flex;text-align:justify;">
                    <img class="info_img" src="../../static/img/icons/info.png" alt="">
                    <span class="sureTip1" v-html="panelInfo"></span>
                </div>
                <div class="shareFooter infoFooter">
                    <div class="primary btnClass" @click="closeInfoPanel()">{{panelBtn}}</div>
                </div>
            </div>
        </div>
        <div class="model_service_box fail_box" v-show='surePanel'>
            <div class="sureAlert" v-show='surePanel'>
                <div class="title move">
                    <p class="title-p">企业名认证未通过</p>
                    <span class="close_c"  @click="sureCheck()">
                        <i class="iconfont icon-close"></i>
                    </span>
                </div>
                <div class="sureContent">
                    <img class="info_img" src="../../static/img/icons/info.png" alt="">
                    <span class="sureTip">{{sureInfo}}</span>
                </div>
                <div class="shareFooter">
                    <span class="primary text" @click="sureCheck()">修改</span>
                    <span class="footer-button text" @click="closeSurePanel()">取消</span>
                </div>
            </div>
        </div>
        <div class="sel_box" v-show="(selSuccessPanel && isLastPage || noCompany) && isPop" >
            <div :class="'selection_success_container '+(isCamName==1?'':companyNameChecked?'selection_success_container1':'selection_success_container2')"  v-show="isOldPage">
                <div class="selection_success_title" >
                    <span class="pc-head">{{(isCamName==1)?'温馨提示':'企业名认证未通过'}}</span>
                    <span class="layui-layer-setwin" @click="companyNameChecked=true;(isCamName!=1?closeConfirmBox($event):closeSelBox())"><a class="layui-layer-ico layui-layer-close layui-layer-close1" href="javascript:;"></a></span>
                </div>
                <div class="selection_seccess_content" style="display: flex;"><img src="../../static/img/icons/confirm.png">
                    <div style="text-align: justify;">
                        <div v-if="(isCamName==1||(isCamName!=1&&companyNameChecked==true))&& noPass ">感谢您完成留资！<br></div>
                        <div v-if="(isCamName==1||(isCamName!=1&&companyNameChecked==true))&& !noPass ">您的单位名认证未通过！<br></div>
                        {{isCamName==1?'您的单位名认证通过！系统奖励500魔豆！':'可重新认证单位名信息（请填单位全称），获取500魔豆奖励！若放弃认证，后续可在“在线开发-个人信息”中修改单位名信息，但就不会再有奖励。'}}
                    </div>
                </div>
                <div class="selection_footer_box" :style="isCamName==1?'line-height:50px':''">
                    <a class="selection_footer_button" v-if="isCamName!=1" @click="companyNameChecked=true;closeConfirmBox($event);">重新认证获取500魔豆</a>
                    <a :class="isCamName==1?'selection_footer_button con_btn':'selection_footer_button'" @click="registerSuccess()">{{isCamName==1?'确定':'放弃认证'}}</a>
                </div>
            </div>
            <!-- <div :class="'selection_success_container '+(isCamName==1?'':companyNameChecked?'selection_success_container1':'selection_success_container2')"  v-show="!isOldPage">
                <div class="selection_success_title" >
                    <span class="pc-head">温馨提示</span>
                    <span class="layui-layer-setwin" @click="companyNameChecked=true;closeSelBox();"><a class="layui-layer-ico layui-layer-close layui-layer-close1" href="javascript:;"></a></span>
                </div>
                <div class="selection_seccess_content" style="display: flex; height:115px;"><img src="../../static/img/icons/confirm.png" >
                    <div style="text-align: justify;">
                        <div>感谢您完成留资！<br></div>
                        您的单位名认证未通过！后续可在“在线开发-个人信息”中修改单位名信息。
                    </div>
                </div>
                <div class="selection_footer_box" style="line-height:50px">
                    <a class="selection_footer_button con_btn" @click="registerSuccess()">确定</a>
                </div>
            </div> -->
        </div>
    </div>
</template>
<script>
import bus from '../assets/js/eventBus.js';
import pinyinMatch from 'pinyin-match'
export default {
    name: "modeling_box",
    data: function() {
        return{
            mmdId:'',
            sendState:true,
            phoneNumber:"",
            phoneNumberOk:'',
            time:60,
            sending:false,
            code:'',
            number:1,
            loading:false,
            camName:'',
            perName:'',
            perJob:'',
            originPerJob:'',
            originCamName:'',
            perCompanyResult:'',
            perJobResult:'',
            uid:'',
            toolinfo:'',
            userNick:'',
            oldNick:'',
            orderError:'',
            orderSuccess:false,
            type:'',
            subject:'',
            isCamName:0,//0:未验证 1：验证成功 2：验证失败
            isCompany:0,//0:未验证 1:初步成功 2:初步验证失败
            isPerName:0,
            isJobName:0,
            mmdId:'',
            mdTip: false,
            showPanel:false,
            showCompanyPanel:false,
            panelInfo:"",
            surePanel:false,//认证未通过
            sureInfo:"",
            token:'',
            accessToken:'',
            submitComName:"",
            isCheck:false,
            matchList:[],
            matchCom:false,
            matchCheck:false,
            inter:'',
            login_times:0,//登录次数
            panelTitle:'企业名认证通过',
            panelBtn:'确定',
            // showClose:false,//是否显示关闭按钮
            isShow:true,
            sending:false,
            isPhoneNull:false,
            otherIsNull:false,
            phoneCode:'',
            step:1,
            stepALL:1,
            isShowPwd:0, //0 不需要设置密码 1 设置密码 2 显示设置密码框
            pwdAgain:'',
            pwdAgaintip:false,
            pwdOld:'',
            pwdOldtip:false,
            userNicktip:false,
            titleTip:'请先补充您的完整信息，谢谢！',
            currentUrl: '', // 留资页面定位url地址，可以精确统筹到页面留资
            openPage:'',
            alertTitle:'温馨提示',
            from:'',
            isflagShow:0,//1.有值，初步验证通过；2:待验证；3:验证失败
            vclass:'',
            pages:[],
            checkSuccess:false,
            value:[],
            item:[],
            companyValue:[],
            workShow:false,
            companyBgShow: false,
            findShow:false,
            wordActiveClass:'',
            searchResultJob:[],
            companyNameList:'',
            currentIndex:0,
            companyCurrentIndex:0,
            selSuccessPanel: false,
            successInfo:0,
            companyNameChecked:false,
            showStep:true,
            moreneeds:'',
            checkCode:[],
            checkScene:[],
            checkProduct:[],
            selectedList:[],
            isLastPage:false,
            noCompany: false,
            isOldPage: true,
            noPass: false,
            isClose:false,
            noMoreExtend:false,
            isPop:true,
            referee:'',
            isMmdidLegitimate:''
        }
    },
    created () {
        this.workDate();
        this.referee='';
        document.addEventListener('click', (e) => {
            if (this.$refs.showPanel) {
                let isSelf = this.$refs.showPanel.contains(e.target)
                if (!isSelf) {
                    this.workShow = false;
                    if(this.$refs.showCompanyPanel){
                        let isCompanySelf = this.$refs.showCompanyPanel.contains(e.target)
                        if (!isCompanySelf) {
                            this.companyBgShow = false;
                        }
                    }
                    this.$nextTick(()=>{
                        if(this.openPage=='info') {
                            this.otherClick();
                        }
                    })
                }
            }
        })
        if(self!=top) {
            $('body, html').css({'background':'rgba(0,0,0,0)'});
        }
    },
    computed: {
        searchResult(){
            var _this=this;
            return  _this.value;
        }
    },
    methods: {
        clearJob(e){
            e=e||window.event;
            e.stopPropagation();
            e.preventDefault();
            this.perJob='';
            this.currentIndex=0;
            this.workShow=true;
            this.findShow=false;
            if(self!=top) {
                if(this.workShow) {
                    window.parent.postMessage('addMoreStyle','*');
                    $('body, html').css({'background':'rgba(0,0,0,0)'});
                } else {
                    var height = '372px';
                    var width = '540px';
                    window.parent.postMessage({
                        type:"showDialog",
                        height:height,
                        width:width
                    },'*');
                }
            }
        },
        clearCompany(e){
            e=e||window.event;
            e.stopPropagation();
            e.preventDefault();
            this.camName='';
            this.companyCurrentIndex=0;
            this.companyBgShow=false;
        },
        getCurrent(job,e) {
            if(e) {
                e=e||window.event;
                if(e.target&&$(e.target).prop('id')=='text'&&this.searchResultJob&&this.searchResultJob.length) {
                    if(e.which==38) {
                        this.currentIndex--;
                        if(this.currentIndex<0) this.currentIndex=this.searchResultJob.length;
                    } else if(e.which==40) {
                        this.currentIndex++;
                        if(this.currentIndex>this.searchResultJob.length) this.currentIndex=0;
                    }
                    if(e.which==40||e.which==38) {
                        if(this.currentIndex) {
                            var str=$('.search-firstli-scroll:visible').children('li').eq(this.currentIndex-1).text();
                            if(str) {
                                // $('.search-firstli-scroll:visible').parents('.modeling_content').find('#text').val(str);
                                this.perJob=str;
                                // console.log($('.search-firstli-scroll:visible').children('li').eq(this.currentIndex-1)[0].offsetTop,$('.search-firstli-scroll:visible').parent().height())
                                // if($(this.currentIndex-1)[0].offsetTop-$('.search-firstli-scroll:visible').parent().height()) {
                                //     $('.search-firstli-scroll:visible').scrollTop($('.search-firstli-scroll:visible').children('li').eq(this.currentIndex-1)[0].offsetTop-$('.search-firstli-scroll:visible').parent().height());
                                // }
                            }
                        } else {
                            this.perJob=this.originPerJob;
                        }
                        return;
                    }
                }
            }
            if(job) {
                this.originPerJob=job;
                this.findShow=true;
                var order=[];
                var list=[];
                this.value.map(item=>{
                    item.children.map(v=>{
                        v.children.map(_v=>{
                            var m=pinyinMatch.match(_v.name,job.toUpperCase());
                            if(m) {
                                list.push({name:_v.name,type:item.name,industry:v.name});
                            }
                        })
                        if(v.name.toUpperCase().indexOf(job.toUpperCase()) > -1){
                            return order.push({i_o:item.order,o_o:v.order})
                        }
                    })
                 })
                 this.searchResultJob=list;
                 if(!this.searchResultJob.length) this.currentIndex=0;
                 if(order.length) {
                     this.showindexparentlist(order[0].i_o);
                     $('.work_bg .work-us .work-list ul li.varietylist span[data-order="'+order[0].o_o+'"]').parent().addClass('showindexlist');
                     $('.work_bg .work-us .work-list ul li.varietylist').not($('.work_bg .work-us .work-list ul li.varietylist span[data-order="'+order[0].o_o+'"]').parent()).removeClass('showindexlist');
                     $('.work_bg .work-us .work-list ul li.varietylist span[data-order="'+order[0].o_o+'"]').addClass('active');
                     $('.work_bg .work-us .work-list ul li.varietylist').not($('.work_bg .work-us .work-list ul li.varietylist span[data-order="'+order[0].o_o+'"]')).removeClass('active')
                 }
            } else {
                this.findShow=false;
                this.currentIndex=0;
            }
            this.workShow = true;
            if(self!=top) {
                if(this.workShow) {
                    window.parent.postMessage('addMoreStyle','*');
                    $('body, html').css({'background':'rgba(0,0,0,0)'});
                } else {
                    var height = '372px';
                    var width = '540px';
                    window.parent.postMessage({
                        type:"showDialog",
                        height:height,
                        width:width
                    },'*');
                }
            }
        },
        deb(fn, wait, flage) {
              // 手写防抖函数
            const that = this;
            return function () {
                // eslint-disable-next-line prefer-rest-params
                const args = arguments;
                if (flage && !that.time) {
                    fn.apply(this, args);
                }
                if (that.time) {
                    clearTimeout(that.time);
                    that.time = null;
                }
                that.time = setTimeout(() => {
                    that.time = null;
                    fn.apply(this, args);
                }, wait);
            };
        },
        getCurrentCompany(camName,e){
            let self = this;
            if(e) {
                e=e||window.event;
                if(e.target&&$(e.target).prop('id')=='companyRec') {
                    if(e.which==40||e.which==38) {
                        if(e.which==38) {
                            self.companyCurrentIndex--;
                            if(self.companyCurrentIndex<0) self.companyCurrentIndex=self.companyNameList.length;
                        } else if(e.which==40) {
                            self.companyCurrentIndex++;
                            if(self.companyCurrentIndex>self.companyNameList.length) self.companyCurrentIndex=0;
                        }
                        if(self.companyCurrentIndex) {
                            var str=$('.company-list').children('li').eq(self.companyCurrentIndex-1).text();
                            if(str) self.camName=str;
                        } else {
                            this.camName=this.originCamName;
                        }
                        return;
                    }
                }
            }
            if(e.which==9||e.which==13){
                this.hideCompanyDiv();
                return;
            }
            this.originCamName=camName;
            if(camName.length<2) return self.companyBgShow=false;
            if(escape(camName).indexOf("%u")<0) return self.companyBgShow=false;
            var fn=function(){
                $.ajax({
                    url:'https://www.thingjs.com/api/companySearch?name='+camName+'',
                    type: 'get',
                    dataType: 'json',
                    success: function(data){
                        self.companyNameList=data.companyNameList;
                        if(data.companyNameList){
                            self.companyBgShow=true;
                        }else{
                            self.companyBgShow=false;
                        }

                    }
                })
            }
            self.deb(fn, 500, false)();
        },
        // findResultJob(){
        //     var _this=this;
        //     var list=[];
        //     if(_this.perJob) {
        //         _this.value.map(item=>{
        //             item.children.map(v=>{
        //                 v.children.map(_v=>{
        //                     var m=pinyinMatch.match(_v.name,_this.perJob.toUpperCase());
        //                     if(m) {
        //                         return list.push({name:_v.name,type:item.name,industry:v.name});
        //                     }
        //                 })
        //             });
        //         })
        //     }
        //     _this.searchResultJob=list;
        // },
        showindexparentlist(order) {
            $('.work_bg .work-us .work-list > ul.firstli-scroll > li').not($('.work_bg .work-us .work-list > ul.firstli-scroll > li[data-order="'+order+'"]')).removeClass('active');
            $('.work_bg .work-us .work-list > ul.firstli-scroll > li[data-order="'+order+'"]').addClass('active');
        },
        showindexlist(index,removeActive) {
            debugger
            if(!removeActive) {
                $('.work_bg .work-us .work-list > ul.firstli-scroll > li').eq(index).addClass('active');
                $('.work_bg .work-us .work-list > ul.firstli-scroll > li > span').eq(index).addClass('active');
                $('.work_bg .work-us .work-list > ul.firstli-scroll > li').not($('.work_bg .work-us .work-list > ul.firstli-scroll > li').eq(index)).removeClass('active');
               $('.work_bg .work-us .work-list > ul.firstli-scroll > li > span').not($('.work_bg .work-us .work-list > ul.firstli-scroll > li > span').eq(index)).removeClass('active');
                if(index!=0){
                    $('.work_bg .work-us .work-list > ul.firstli-scroll > li:first-child ul').css("display","none");
                }else{
                    $('.work_bg .work-us .work-list > ul.firstli-scroll > li:first-child ul').css("display","block");
                    $('.work_bg .work-us .work-list > ul.firstli-scroll > li > ul.secondli-scroll > li > ul.lasrtli-scroll').css("display","flex");
                }
                if(self!=top) {
                    if(this.workShow) {
                        window.parent.postMessage('addMoreStyle','*');
                        $('body, html').css({'background':'rgba(0,0,0,0)'});
                    } else {
                        var height = '372px';
                        var width = '540px';
                        window.parent.postMessage({
                            type:"showDialog",
                            height:height,
                            width:width
                        },'*');
                    }
                }
            } else {
                this.removeActive();
            }
            $('.work_bg .work-us .work-list ul li.varietylist').eq(index).addClass('showindexlist');
            $('.work_bg .work-us .work-list ul li.varietylist').not($('.work-us .work-list ul li.varietylist').eq(index)).removeClass('showindexlist');
        },
        removeActive(){
            $('.work_bg .work-us .work-list ul.firstli-scroll li').removeClass('active');
        },
        otherClick(){
                if(!this.workShow) {
                    if(self!=top) {
                        var height = '372px';
                        var width = '540px';
                        window.parent.postMessage({
                            type:"showDialog",
                            height:height,
                            width:width
                        },'*');
                        window.parent.postMessage('closeMoreStyle','*');
                        $('body, html').css({'background':'none'});
                    }
                }
        },
        hideDiv(e){
            if(e) {
                var target=e.target;
                if($(target).parents('.work_bg').length||$(target).prop("id")=="text"){
                    return
                }
            }
            this.workShow=false;
            this.checkJob();
            if(self!=top) {
                var height = '372px';
                var width = '540px';
                window.parent.postMessage({
                    type:"showDialog",
                    height:height,
                    width:width
                },'*');
                window.parent.postMessage('closeMoreStyle','*');
                $('body, html').css({'background':'none'});
            }
        },
        hideCompanyDiv(e){
            if(e){
                let target = e.target;
                if($(target).parents(".company-bg").length){
                    return;
                }
            }
            this.companyBgShow=false;
        },
        registerSuccess(){
            var _this = this;
            this.noCompany = false;
            this.isOldPage = false;
            this.selSuccessPanel = false;
            _this.stepNext();
            if(self!=top) {
                window.parent.postMessage({
                    type:"changeStyle",
                    height:"457px",
                    width:"800px"
                } ,'*');
                $('body, html').css({'background':'rgba(0,0,0,0)'});
            }

        },
        closeConfirmBox(e){
            this.noCompany = false;
           var _this = this;
           _this.selSuccessPanel=false;
           $(".sel_box").hide();
           if(_this.successInfo!=0||_this.isCamName!=1) {
               var e=e||window.event;
            //    console.log( $('.model_service_container.campanyService:visible').find('.input_item.campanyInfo.campanynameInput input'))
               $('.model_service_container.campanyService:visible').find('.input_item.campanyInfo.campanynameInput input').addClass('focused').focus();
           }
        },
        // 点击职位信息时
        workKey(value,index,e){
            var e = e||window.event;
            var dom=e.target;
            $('.work_bg .work-us .work-list > ul.firstli-scroll > li > ul.secondli-scroll > li > ul.lasrtli-scroll').removeClass('active');
            $(dom).addClass('active');
            this.perJob = value.name;
            // this.workShow = false
            this.perJobResult = '';
            this.hideDiv();
        },
        // 点击公司信息时
        companyKey(item,index,e){
            var e = e||window.event;
            e.stopPropagation();
            var dom=e.target;
            $('.company-bg .company-list li').removeClass('active');
            $(dom).addClass('active');
            this.camName = item.companyName;
            this.perCompanyResult = '';
            // this.originCamName='';
            this.hideCompanyDiv();
        },
        // 职位模糊查询
        // inputFunc(){
        //     if(this.perJobResult.length||this.perJobResult.length==0){
        //         this.workShow = true;
        //         if(!this.perJob)  this.showindexlist(0);
        //     }else {
        //          this.workShow = false;
        //         $('.work-us .work-list ul.firstli-scroll li').removeClass('active');
        //     }
        // },
        // 请求职位数据
        workDate(){
            let self = this;
            this.$reqs.get("/user/querySelectIndustry").then((result)=>{
                if(result.data && result.status == 200 && result.data.state && result.data.content && result.data.content.total != 0){
                    self.value=result.data.content.list;
                    // console.log(result.data)
                }else{
                    console.log("数据暂无")
                }
            })
        },
        closeSelBox(){
           var _this = this;
           _this.selSuccessPanel=false;
           $(".sel_box").hide()
           _this.stepNext();
        },
        // 选择职位失去锚点
        officeNameFocus(){
            this.workShow = false;
        },

        closeSurePanel:function(){
            this.surePanel = false;
            this.submitOrder();
        },
        sureCheck:function(){
            this.surePanel = false;
        },
        closeErrorBox:function(){
            this.orderError = false;
            if(this.mdTip){
                this.mdTip = false;
                this.showTool();
            }
        },
        closeInfoPanel(){
            this.showPanel = false;
            if(this.mdTip){
                this.mdTip = false;
                this.showTool();
            }
            this.$emit('hidePanel');
            var loginGo = window.localStorage.getItem('signal');
            var fromThingJS = window.localStorage.getItem('fromThingJS');
            var fromStoreInfo = window.localStorage.getItem('fromStoreInfo');
            var loginMessage = window.localStorage.getItem('loginMessage');
            if(fromStoreInfo && loginGo  && !fromThingJS){
                window.loginContinue(JSON.parse(loginMessage));
                window.localStorage.removeItem('signal');
                window.localStorage.removeItem('loginMessage');
                window.localStorage.removeItem('fromStoreInfo');
            }
            window.parent.postMessage('closePanel','*');
        },
        closeSuccessBox:function(){
            this.orderSuccess = false;
            // this.hidePanel(true);
            this.showTool();
        },
        hidePanel:function(success){

            if(success){
                this.$emit('hidePanel',success);
                this.$emit('hidePanelC');
            }else{
                this.$emit('hidePanel');
                this.$emit('hidePanelC');
            }
            this.step = 1;
            window.parent.postMessage('closePanel','*');
        },
        matchCampanyName:function(data){
            if(data.tatal < 0){
                this.isCamName = 2;
                return;
            }
            let list = data.list;
            let i = 0
            for(i = 0; i < list.length; i++){
                if(list[i].name == this.camName){
                    this.isCamName = 1;
                    break;
                }
            }
            if(i >= list.length){
                this.isCamName = 2;
            }
        },
        selectCompany:function(event) {
            this.camName =  $(event.target).text();
            this.submitComName = $(event.target).text();
            this.matchCom = false;
            this.isCamName = 1;
            this.isCompany = 1;
            this.matchCheck = true;
            event.stopPropagation()

        },
        clickDocument:function(){
            if(this.matchCom){
                this.matchCom = false;
                this.matchCheck = false;
                this.isCamName = 0;
            }
        },
        checkCampanyName2:function(){
            var _this = this;
            if(!_this.camName) return;
            _this.matchCheck = false;
            if(this.isMmdidLegitimate) {
                this.$reqs.get("/user/checkCampanyName?campanyName="+this.camName+"&mmdId="+this.mmdId+"&token="+($.cookie('token')||_this.token)).then(function(result){
                    if(result && result.status == 200){
                        if(result.data&&result.data.Status==200){
                            var data = result.data.Result;
                            _this.matchList = data;
                            _this.matchCom = true;
                            _this.isCamName=1;
                        }
                    }else{
                        _this.isCamName = 2;//验证失败
                    }
                    this.loading = false;
                })
            }
        },
        checkCampanyName:function(){
            var reg = /^[\u4E00-\u9FA5A-Za-z（）()\s]{2,}$/;
            var _this = this;
            _this.camName = _this.camName.trim();
            if(reg.test(_this.camName)){
                if(_this.isCompany == 2) {
                    _this.isCompany == 2
                }else {
                    _this.isCompany = 1;
                }
                _this.isflagShow = 2;
            }else{
                _this.isCompany = 2;
                // _this.isflagShow = 3;
            }
            if(self!=top) {
                var height = '372px';
                var width = '540px';
                window.parent.postMessage({
                    type:"showDialog",
                    height:height,
                    width:width
                },'*');
            }
        },
        checkCampanyName_new:function(){
            var _this = this;
            if(!_this.camName) {
                this.isflagShow = 3;
                if(!this.perName) this.isPerName = 2;
                if(!this.perJob) this.isJobName=2;
                return;
            }
            if(!this.perName) this.isPerName = 2;
            if(!this.perJob) this.isJobName=2;
            if(this.isMmdidLegitimate) {
                this.$reqs.get("/user/checkCampanyName?campanyName="+this.camName+"&mmdId="+this.mmdId+"&token="+($.cookie('token')||_this.token)).then(function(result){
                    _this.isCheck = true;
                    _this.isCamName = 2;
                    if(result && result.status == 200){
                        if(result.data&&result.data.Status==200){
                            _this.isCamName=1;
                        }
                    }else{
                        _this.isCamName = 2;//验证失败
                    }
                    if( _this.isCamName&&_this.isPerName == 1 && _this.isJobName == 1 ){
                    // if( _this.isCamName&&_this.isPerName == 1 && _this.isJobName == 1 && (_this.isCompany == 1 || _this.isCompany ==4)){
                        if( _this.isCamName == 1 ){//验证成功，直接提交
                            _this.loading = true;
                            _this.successInfo=0;
                            _this.submitOrder();
                        }else if( _this.isCamName == 2 ){
                            //验证失败,提示
                            if( _this.isCheck&&!_this.companyNameChecked ){//如果此次提交进行检测，并且检测结果失败，提示
                                _this.loading = false;
                                // _this.successInfo=1;
                                _this.isflagShow = 3;
                                _this.companyNameChecked=true;
                                // _this.selSuccessPanel=true;
                                // _this.sureInfo = "您的企业名认证未通过。首次通过企业名认证可奖励500魔豆，您要重新修改企业名称再次认证吗？"
                                // _this.surePanel = true;
                                // _this.submitOrder();
                            }else{
                                _this.loading = true;
                                _this.submitOrder();
                            }
                        }else{
                            _this.loading = true;
                            _this.submitOrder();
                        }
                    } else if(!_this.isCamName) {
                        _this.checkCampanyName();
                    } else {
                        _this.loading = false;
                        _this.isflagShow = 3;
                        _this.companyNameChecked=true;
                        _this.isJobName=1;
                        // _this.checkCampanyName2();
                    }
                })
            }
        },
        checkName:function(){
            var reg = /^[\u4E00-\u9FA5A-Za-z（）()\s]{2,}$/;
            var _this = this;

            if(reg.test(_this.perName)){
                _this.isPerName = 1;
            }else{
                _this.isPerName = 2;
            }
            if(self!=top) {
                var height = '372px';
                var width = '540px';
                window.parent.postMessage({
                    type:"showDialog",
                    height:height,
                    width:width
                },'*');
            }
        },
        checkJob:function(){
            if( this.perJob.length >= 2 ){
                this.isJobName = 1;
            }else{
                this.isJobName = 2;
            }
        },
        setCookie:function(name, value, d, domain) {
            var Days = 1;
            if (d) Days = d;
            var exp = new Date();
            exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);

            var hostName = window.location.hostname;
            if(hostName == "store.thingjs.com") {
                domain = ".thingjs.com";
            }else if(hostName == "www.3dmmd.cn") {
                domain = ".3dmmd.cn";
            }

            if(domain){
                document.cookie =name + "=" + escape(value) + ";domain="+domain+";expires=" + exp.toGMTString() + "; path=/;";
            }else{
                // console.log(window.location.hostname)s
                document.cookie = name + "=" + escape(value) + ";expires=" + exp.toGMTString() + "; path=/";
            }
        },
        submitOrder:function(){
            var _this = this;
            if(this.isMmdidLegitimate) {
                var para = {office:this.perJob,company:this.camName,namebyCam:this.perName,companyState:Number(this.isCamName),mmdId:this.mmdId,currentUrl:this.currentUrl };
                var url="/user/setUserInfo?token="+($.cookie('token')||_this.token);
                if(self!=top) url=url+'&mmdId='+this.mmdId;
                this.$reqs.post(url,para).then(function(result) {
                    if(result.status == 200 && result.data && result.data.code == 200){
                        // 企业信息留资
                        // window.AnalysysAgent && window.AnalysysAgent.track('user_submit_order');
                        _this.loading = false;
                        // 打开下一个面板
                        if(_this.checkSuccess && _this.isCamName == 1){
                            _this.$reqs.get('/user/systemAddMb?='+_this.mmdId+'&token='+($.cookie('token')||_this.token)).then(function(result){});

                        }
                        // _this.stepNext();
                        // _this.isShow=false
                        _this.selSuccessPanel=true;
                    }
                }).catch(function(error) {
                    console.log(error);
                });
            }
        },
        async makeOrder(){
            var _this = this;
             if(self!=top) {
                var height = '372px';
                var width = '540px';
                window.parent.postMessage({
                    type:"showDialog",
                    height:height,
                    width:width
                },'*');
            }

            if( this.submitComName != this.camName){//相等表示已经检测过，不在第二次检测
                if(self!=top) {
                        var height = '372px';
                        var width = '540px';
                        window.parent.postMessage({
                            type:"showDialog",
                            height:height,
                            width:width
                        },'*');
                    }
                this.loading = true;
                // 检测公司名称
                if( this.camName && this.isMmdidLegitimate){
                    this.submitComName = this.camName;
                    this.isCheck = true;
                    try {
                        var result  = await this.$reqs.get("/user/checkCampanyName?campanyName="+this.camName+"&mmdId="+this.mmdId+"&token="+($.cookie('token')||_this.token),{timeout:1000});
                        if(result && result.status == 200){
                            if(result.data && result.data.Status == 200){
                                _this.isCamName = 1;
                                _this.isCompany = 1;
                                _this.isflagShow = 1;
                                _this.checkSuccess = true;
                            // _this.matchCampanyName(result.data.data);
                            }else{
                                //认证未通过 1:3,2:2,3:3
                                _this.isCompany = 2;
                                _this.isCamName = _this.isCamName==1?3:_this.isCamName;
                                // _this.isflagShow = 3;
                            }
                        }else{
                            _this.isCamName = 4;//验证失败
                            // _this.isflagShow = 3;
                            _this.isCompany = 2;
                        }
                    } catch (error) {
                         _this.isCamName = 4;//验证失败
                         _this.isCompany = 2;
                    }
                        this.loading = false;
                } else{
                    // _this.isflagShow = 3;
                    _this.isCompany = 2;
                    _this.isCamName = _this.isCamName==1?3:_this.isCamName;
                    this.loading = false;
                    }
                    $('.sel_box').css({'height':'372px'});
                    var height = '372px';
                    var width = '540px';
                    if(self!=top) {
                        var height = '372px';
                        var width = '540px';
                        window.parent.postMessage({
                            type:"showDialog",
                            height:height,
                            width:width
                        },'*');
                    }
            }else{
                if(self!=top) {
                    var height = '372px';
                    var width = '540px';
                    window.parent.postMessage({
                        type:"showDialog",
                        height:height,
                        width:width
                    },'*');
                }
                if(this.isCompany != 1 && this.isCompany != 4 ) {
                    this.noCompany = true;
                }
                this.isCheck = false;
                if(this.isCompany == 2) {
                    this.isCompany == 2
                }else {
                    this.isCompany = 1;
                }
                if(!this.noCompany) {
                    this.isOldPage = true;
                    _this.stepNext();
                    if(self!=top) {
                        window.parent.postMessage({
                            type:"changeStyle",
                            height:"457px",
                            width:"800px"
                        } ,'*');
                        $('body, html').css({'background':'rgba(0,0,0,0)'});
                    }
                }
                // this.isflagShow = 3;
            }
            _this.checkCampanyName_new();
            // else{
            //     _this.orderError = "请您填写正确信息！"
            // }
        },
        showTool:function(){
            var _this = this;
            if(_this.from){
                window.parent.postMessage({to:_this.from,toolInfo:_this.toolinfo,step:_this.step+" / "+_this.stepALL,subject:_this.subject},'*');
                _this.hidePanel();
                return ;
            }
            if(_this.type == "buy"){
                window.parent.postMessage('buy','*');
            }else if(_this.type == "document"){
                window.parent.postMessage('document','*');
            }else if(_this.type == "releasePro"){
                window.parent.postMessage('releasePro','*');
            }else if(_this.type == "tick"){
                window.parent.postMessage('tick','*');
            }else if(_this.type == "downDocum"){
                bus.$emit('downInfo',{infos:_this.toolinfo,step:_this.step+" / "+_this.stepALL});
            }else if(_this.type == "shopScene"){
                bus.$emit('shopScene',{infos:_this.toolinfo,step:_this.step+" / "+_this.stepALL});
            }else if(_this.type == "buyScene"){
                bus.$emit('buyScene',{infos:_this.toolinfo,step:_this.step+" / "+_this.stepALL});
            }else if(_this.type == "buyModel"){
                bus.$emit('buyModel',{infos:_this.toolinfo,step:_this.step+" / "+_this.stepALL});
            }else if(_this.type == "mmdShop"){
                window.parent.postMessage('mmdShop','*');
            }else if(_this.type == "fromModelServer"){
                bus.$emit('fromModelServer',{infos:{toolInfo:_this.toolinfo,step:_this.step+" / "+_this.stepALL}});
            }else if(_this.type == "fromdevServer"){
                bus.$emit('fromdevServer',{step:_this.step+" / "+_this.stepALL});
            }else if(_this.type == "fromVIPServer"){
                bus.$emit('fromVIPServer',{step:_this.step+" / "+_this.stepALL});
            }else if(_this.type == "view"){
                bus.$emit('view',{to:_this.subject,step:_this.step+" / "+_this.stepALL,toolInfo:_this.toolinfo});
            }else if(_this.type == "studio"){
                bus.$emit('studio',{to:_this.subject,toolInfo:_this.toolinfo});
            }
            _this.type = '';
            _this.hidePanel();
        },
        getinfosItem:function(data){
            this.mmdId = data.infos.mmdId;
            this.userNick = data.infos.userNick;
            this.type = data.infos.type?data.infos.type:'';
            this.isCamName = data.infos.companyState;

            if(data.infos.msg){
                var msg = data.infos.msg;
                this.subject = msg.subject;
                this.alertTitle = msg.title?msg.title:this.alertTitle;
                this.titleTip = msg.titleTip?msg.titleTip:this.titleTip;
                this.toolinfo = msg.toolInfo;
                this.vclass = msg.class;
                // 新增留资页面定位url地址，可以精确统筹到页面留资
                this.currentUrl = msg.currentUrl ? msg.currentUrl : this.currentUrl
            }
            if(data.infos.company){
                this.camName = data.infos.company;
                this.submitComName = data.infos.company;
                this.isCompany = 4;
                this.isflagShow = 1;
            }
            if(data.infos.office){
                this.perJob = data.infos.office;
                this.isJobName = 1;
            }
            if(data.infos.namebyCam){
                this.perName = data.infos.namebyCam;
                this.isPerName = 1;
            }
        },
        startInter:function(){
            var _this = this;
            this.inter = setTimeout(function(){
                _this.checkCampanyName2();
                clearTimeout(_this.inter);
            },3000)
        },
        cleatInter:function(){
            clearTimeout(this.inter);
        },
        sendCode:function(){
            if(!this.phoneNumber || !this.phoneNumberOk){return;}
            $.ajax({
                url: "https://www.thingjs.com/uinapi/register/getPhoneVCodeForRegister?phoneNumber=" + this.phoneNumber,
                type: "get",
                async:false,
                success: function (res) {
                    if (res.code == '0') {
                        layer.msg(res.msg ,{offset:['45%']});
                    } else if (res.code == '500') {
                        layer.msg(res.msg) ,{offset:['45%']};
                    }
                }
            })
            this.sending = true;
            this.time = 60;
            var _this = this
            var timer = setInterval(function(){
                _this.time = _this.time - 1;
                if(_this.time == 0){
                    _this.sending = false;
                    clearInterval(timer);
                }
            }, 1000)
        },
        checkPhone:function(){
            var _this = this;
            var reg = /^1[0-9]{10}$/; //验证规则
            if( reg.test(_this.phoneNumber)){
                _this.phoneNumberOk = true;
                _this.sendState = false;
            }else{
                _this.phoneNumberOk = false;
                _this.sendState = true;
            }
        },
        stepNext:function(){
            this.step++;
            if(this.pages[this.step-1]){
                //进入下一步
                var height = '372px';
                var width = '540px';
                switch(this.pages[this.step-1]){
                    case "info":
                        height = '372px';
                        width = '540px';
                        break;
                    case "phone":
                        height = '303px';
                        width = '540px';
                        break;
                    case "setPwd":
                        height = '342px';
                        width = '540px';
                        break;
                    case 'company_extend':
                        height = '457px';
                        width = '800px';
                        break;
                }
                if(this.pages[this.step-1]=='company_extend') {
                    window.parent.postMessage({
                        type:"changeStyle",
                        height:height,
                        width:width
                    } ,'*');
                } else {
                    window.parent.postMessage({
                        type:"showDialog",
                        height:height,
                        width:width
                    } ,'*');
                }
                this.openPage = this.pages[this.step-1];
            }else{//跳到其他页
                this.showTool();
            }
        },
        bindPhone:function(){
            var _this = this;
            if(!_this.phoneNumber || !_this.phoneNumberOk || !_this.phoneCode || !_this.isMmdidLegitimate) return;
            _this.loading = true;
            var token ='Bearer '+ ($.cookie('accessToken')||_this.accessToken);
            var userId = _this.getUserName('id');
            _this.$reqs.post("/user/phoneBind",{token:token,phone: _this.phoneNumber,code:_this.phoneCode,userId:userId,currentUrl:_this.currentUrl}).then(function(res) {
                if (res.data.status == '0') {
                    var data={
                        phoneVerify: _this.phoneNumber,mmdId: _this.mmdId,currentUrl:_this.currentUrl
                    }
                    // if(_this.referee&&_this.referee.trim().length) {
                    //     data.referee=_this.referee.trim()
                    // }
                    _this.$reqs.post("/user/setUserPhone?token="+($.cookie('token')||_this.token),data).then(function(result) {
                        if (result.data.code == '200') {
                            // 手机号留资
                            // window.AnalysysAgent && window.AnalysysAgent.track('user_bind_phone');
                            _this.loading = false;
                            _this.stepNext();
                        }else{
                            layer.msg(result.data.content.code,{offset:['45%']});
                        }
                    })
                }else if(res.data.status == '1'){
                    layer.msg(res.data.msg,{offset:['45%']});
                } else {
                    layer.msg('绑定手机号失败！',{offset:['45%']});
                }
                _this.loading = false;
            },function(res){
                _this.loading = false;
                layer.msg("手机号绑定失败")
            })
        },
        getUserName:function(name) {
            if (!name) return null;
            var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
            var arr1, reg1 = new RegExp("(^| )" + 'openid' + "=([^;]*)(;|$)");
            var arr2, reg2 = new RegExp("(^| )" + 'headimgurl' + "=([^;]*)(;|$)");
            var userpath = '',headimgurl='';
            if (arr1 = document.cookie.match(reg1)) {
                if (arr = document.cookie.match(reg)) {
                    userpath = '/uploads/wechat/' + unescape(arr1[2]);
                    if (arr2 = document.cookie.match(reg2)) {
                        headimgurl = unescape(arr2[2])
                        //return Base64.decode(unescape(arr[2]));
                        return decodeURI(decodeURI(arr[2]));
                    }
                } else
                    return null;
            } else {
                if (arr = document.cookie.match(reg)) {
                    userpath = '/uploads/moni/' + unescape(arr[2]);
                    return unescape(arr[2]);
                } else
                    return null;
            }
        },
        setPwd:function(){
            var _this = this;
            var userId = _this.getUserName('id');
            //var userId = $.cookie('id');
            var token ='Bearer '+ ($.cookie('accessToken')||_this.accessToken);
            if(!this.pwdAgain || !this.pwdOld) return ;
            if(this.pwdAgaintip || this.pwdOldtip) return ;
            if(!this.userNick) return;
            if(this.userNick == this.oldNick){
                _this.setPwd1(userId);
                return ;
            };
            // 根据来源来请求不同路径
            let baseUrl = 'user';
            if(this.currentUrl.includes('//thingjs.com')||this.currentUrl.includes('//www.thingjs.com') ||  this.currentUrl.includes('store.thingjs.com')){
                baseUrl = 'user'
            }else{
                baseUrl = 'register'
            }
            $.ajax({
                url: `https://www.thingjs.com/uinapi/${baseUrl}/resetUserNick?username=`+encodeURI(_this.userNick) +'&userId='+userId,
                type: 'get',
                dataType: 'json',
                headers:{'Authorization': token},
                success: function (res) {
                    if (res.status == '0') {
                        _this.setCookie('name',encodeURI(_this.userNick));
                        _this.setCookie('userNick', encodeURI((_this.userNick)));
                        $(".login-active").html(_this.userNick);
                        $(".login-name").html(_this.userNick);
                        $("#login").html(_this.userNick);
                        $("[data-type='userNick']").text(_this.userNick);
                        _this.setPwd1(userId);
                    }else if(res.status == '1'){
                        layer.msg('昵称已被占用！',{offset:['45%']});
                    } else {
                        layer.msg('昵称修改失败！');
                    }
                }
            })
        },
        setPwd1:function(userId){
            var _this = this;
            var psw = encodeBase64.base64encode(this.pwdAgain).substring(5);
            var token ='Bearer '+ ($.cookie('accessToken')||_this.accessToken);
            var data = {
                userId : userId,
                newPwd : psw
            }
            if(!this.pwdAgain || !this.pwdOld) return ;
            if(this.pwdAgaintip || this.pwdOldtip) return ;
            _this.isShow = false;
            _this.showPanel = true;
            _this.showTipPanel("注册成功","恭喜您注册成功！欢迎来到ThingJS 3D世界！<br/>","确定",true);
            // setTimeout(function(){
            //     window.parent.postMessage({
            //         type:"showDialog",
            //         height:$('#dialogSucc').height()
            //     } ,'*');
            // },50)
            _this.setCookie('name',encodeURI(_this.userNick));
            $(".login-active").html(_this.userNick);
            $(".login-name").html(_this.userNick);
            // 根据来源来请求不同路径
            let baseUrl = 'user';
            if(this.currentUrl.includes('//thingjs.com') || this.currentUrl.includes('//www.thingjs.com') ||  this.currentUrl.includes('store.thingjs.com')){
                baseUrl = 'user'
            }else{
                baseUrl = 'register'
            }
            $.ajax({
                url: `https://www.thingjs.com/uinapi/${baseUrl}/updatePwd`,
                type: 'post',
                dataType: 'json',
                data: data,
                headers:{'Authorization': token},
                success: function (res) {
                    if (res.status == '0') {
                        _this.isShow = false;
                        _this.showPanel = true;
                        _this.showTipPanel("注册成功","恭喜您注册成功！欢迎来到ThingJS 3D世界！<br/>","确定",true);
                        // setTimeout(function(){
                        //     window.parent.postMessage({
                        //         type:"showDialog",
                        //         height:$('#dialogSucc').height()
                        //     } ,'*');
                        // },50)
                        _this.setCookie('name',encodeURI(_this.userNick));
                        $(".login-active").html(_this.userNick);
                        $(".login-name").html(_this.userNick);
                    } else {
                        layer.msg('密码设置失败！');
                    }
                }
            })
        },
        checkUserNick:function(){//不允许为空且唯一
            var reg = /^[\u4E00-\u9FA5A-Za-z（）()\s]{2,}$/;
            var _this = this;
            if(reg.test(_this.userNick)){
                _this.userNicktip = true;
            }else{
                _this.userNicktip = false;
            }
        },
        checkPwd:function(type){
            var _this = this;
            if(type){
                if(_this.pwdAgain !== _this.pwdOld){
                    _this.pwdAgaintip = true;
                }else{
                    _this.pwdAgaintip = false;
                }
                return
            }
            if(_this.pwdOld.length>=6 && _this.pwdOld.length<=16){
                _this.pwdOldtip = false;
            }else{
                 _this.pwdOldtip = true;
            }

        },
        showTipPanel:function(title,content,btn,isShowLate){
            var _this = this;
            if(!isShowLate){
                _this.isShow = false;
                _this.showPanel = true;
            }
            _this.panelTitle = title;
            _this.panelBtn = btn;
            _this.panelInfo = content;
        },
        choose(value) {
            let a,b;
            let c = 0;
            a=$('#lowcode').is(":checked");
            b=$('#zerocode').is(":checked");
            if(value == "lowcode") {
                if(a){
                    $(".low").removeClass('active');
                    this.cancleSelected(value)
                }else {
                    $(".label_box .low").addClass('active');
                this.selectedList.push(value);
                 $('.selectedBox').append(`<div class="cancle low" >
                    <div class="canclebox low"><label for="low"><img src="https://www.thingjs.com/guide/static/images/close.png" class="close-icon"></label></div>
                    <div class="label_box lowdown" style="margin-right:0px;width: 150px;">低代码数字孪生</div>
                    </div>`);
                $('.cancle.low').on('mouseenter',function (){
                    $('.canclebox.low').css('display','inline-block');
                    $('.label_box.lowdown').css('background-color','#ffb53e');
                    $('.label_box.lowdown').css('color','#fff');
                })
                $('.cancle.low').on('mouseleave',function (){
                    $('.canclebox.low').css('display','none');
                    $('.label_box.lowdown').css('background-color','rgb(255, 158, 0)');
                    $('.label_box.lowdown').css('color', '#fff');
                })
                $('.cancle.low .canclebox').on('click',function (){
                    $(".label_box .low").trigger("click");
                })
                $('.cancle').css({'display':'inline-block'});
                }


            } else if(value == "zerocode") {
                if(b){
                    $(".zero").removeClass('active');
                    this.cancleSelected(value)
                }else {
                     $(".label_box .zero").addClass('active');
                    this.selectedList.push(value);
                    $('.selectedBox').append(`<div class="cancle zero" >
                        <div class="canclebox zero"><label for="zero"><img src="https://www.thingjs.com/guide/static/images/close.png" class="close-icon"></label></div>
                        <div class="label_box zerodown" style="margin-right:0px;width: 150px;">零代码数字孪生</div>
                        </div>`);
                    $('.cancle.zero').on('mouseenter',function (){
                        $('.canclebox.zero').css('display','inline-block');
                        $('.label_box.zerodown').css('background-color','#ffb53e');
                        $('.label_box.zerodown').css('color','#fff');
                    })
                    $('.cancle.zero').on('mouseleave',function (){
                        $('.canclebox.zero').css('display','none');
                        $('.label_box.zerodown').css('background-color','rgb(255, 158, 0)');
                        $('.label_box.zerodown').css('color', '#fff');
                    })
                    $('.cancle.zero .canclebox').on('click',function (){
                        $(".label_box .zero").trigger("click");
                    })
                    $('.cancle').css({'display':'inline-block'});
                }


            }
        },
        choosescene(value) {
            let a;
            let b = 0;
            switch (value) {
                case 'city':
                    a=$('#city').is(":checked");
                    if(a){
                        $(".city").removeClass('active');
                        this.cancleSelected(value)
                    }else {
                        $(".label_box .city").addClass('active');
                        $('.selectedBox').append(`<div class="cancle city" >
                            <div class="canclebox city"><label for="city"><img src="https://www.thingjs.com/guide/static/images/close.png" class="close-icon"></label></div>
                            <div class="label_box citydown" style="margin-right:0px;">智慧城市</div>
                            </div>`);
                        $('.cancle.city ').on('mouseenter',function (){
                            $('.canclebox.city').css('display','inline-block');
                            $('.label_box.citydown').css('background-color','#ffb53e');
                            $('.label_box.citydown').css('color','#fff');
                        })
                        $('.cancle.city ').on('mouseleave',function (){
                            $('.canclebox.city').css('display','none');
                            $('.label_box.citydown').css('background-color','rgb(255, 158, 0)');
                            $('.label_box.citydown').css('color', '#fff');
                        })
                        $('.cancle.city .canclebox').on('click',function (){
                            $(".label_box .city").trigger("click");
                        })
                        $('.cancle').css({'display':'inline-block'});
                    }
                    break;
                case 'camp':
                    a=$('#camp').is(":checked");
                    if(a){
                        $(".camp").removeClass('active');
                        this.cancleSelected(value)
                    }else {
                        $(".label_box .camp").addClass('active');
                        $('.selectedBox').append(`<div class="cancle camp">
                            <div class="canclebox camp"><label for="camp"><img src="https://www.thingjs.com/guide/static/images/close.png" class="close-icon"></label></div>
                            <div class="label_box campdown" style="margin-right:0px;">智慧园区</div>
                            </div>`);
                        $('.cancle.camp').on('mouseenter',function (){
                            $('.canclebox.camp').css('display','inline-block');
                            $('.label_box.campdown').css('background-color','#ffb53e');
                            $('.label_box.campdown').css('color','#fff');
                        })
                        $('.cancle.camp').on('mouseleave',function (){
                            $('.canclebox.camp').css('display','none');
                            $('.label_box.campdown').css('background-color','rgb(255, 158, 0)');
                            $('.label_box.campdown').css('color', '#fff');
                        })
                        $('.cancle.camp .canclebox').on('click',function (){
                            $(".label_box .camp").trigger("click");
                        })
                        $('.cancle').css({'display':'inline-block'});
                    }
                    break;
                case 'community':
                    a=$('#community').is(":checked");
                    if(a){
                        $(".community").removeClass('active');
                        this.cancleSelected(value)
                    }else {
                        $(".label_box .community").addClass('active');
                        $('.selectedBox').append(`<div class="cancle community" >
                            <div class="canclebox community"><label for="community"><img src="https://www.thingjs.com/guide/static/images/close.png" class="close-icon"></label></div>
                            <div class="label_box communitydown" style="margin-right:0px;">智慧社区</div>
                            </div>`);
                         $('.cancle.community').on('mouseenter',function (){
                            $('.canclebox.community').css('display','inline-block');
                            $('.label_box.communitydown').css('background-color','#ffb53e');
                            $('.label_box.communitydown').css('color','#fff');
                        })
                        $('.cancle.community').on('mouseleave',function (){
                            $('.canclebox.community').css('display','none');
                            $('.label_box.communitydown').css('background-color','rgb(255, 158, 0)');
                            $('.label_box.communitydown').css('color', '#fff');
                        })
                        $('.cancle.community .canclebox').on('click',function (){
                            $(".label_box .community").trigger("click");
                        })
                        $('.cancle').css({'display':'inline-block'});
                    }
                    break;
                case 'factory':
                    a=$('#factory').is(":checked");
                    if(a){
                        $(".factory").removeClass('active');
                        this.cancleSelected(value)
                    }else {
                        $(".label_box .factory").addClass('active');
                        $('.selectedBox').append(`<div class="cancle factory" >
                            <div class="canclebox factory"><label for="factory"><img src="https://www.thingjs.com/guide/static/images/close.png" class="close-icon"></label></div>
                            <div class="label_box factorydown" style="margin-right:0px;">智慧工厂</div>
                            </div>`);
                        $('.cancle.factory').on('mouseenter',function (){
                            $('.canclebox.factory').css('display','inline-block');
                            $('.label_box.factorydown').css('background-color','#ffb53e');
                            $('.label_box.factorydown').css('color','#fff');
                        })
                        $('.cancle.factory').on('mouseleave',function (){
                            $('.canclebox.factory').css('display','none');
                            $('.label_box.factorydown').css('background-color','rgb(255, 158, 0)');
                            $('.label_box.factorydown').css('color', '#fff');
                        })
                        $('.cancle.factory .canclebox').on('click',function (){
                            $(".label_box .factory").trigger("click");
                        })
                        $('.cancle').css({'display':'inline-block'});
                    }
                    break;
                case 'school':
                    a=$('#school').is(":checked");
                    if(a){
                        $(".school").removeClass('active');
                        this.cancleSelected(value)
                    }else {
                        $(".label_box .school").addClass('active');
                        $('.selectedBox').append(`<div class="cancle school" >
                            <div class="canclebox school "><label for="school"><img src="https://www.thingjs.com/guide/static/images/close.png" class="close-icon"></label></div>
                            <div class="label_box schooldown" style="margin-right:0px;">智慧校园</div>
                            </div>`);
                        $('.cancle.school').on('mouseenter',function (){
                            $('.canclebox.school').css('display','inline-block');
                            $('.label_box.schooldown').css('background-color','#ffb53e');
                            $('.label_box.schooldown').css('color','#fff');
                        })
                        $('.cancle.school').on('mouseleave',function (){
                            $('.canclebox.school').css('display','none');
                            $('.label_box.schooldown').css('background-color','rgb(255, 158, 0)');
                            $('.label_box.schooldown').css('color', '#fff');
                        })
                        $('.cancle.school .canclebox').on('click',function (){
                            $(".label_box .school").trigger("click");
                        })
                        $('.cancle').css({'display':'inline-block'});
                    }
                    break;
                case 'medica':
                    a=$('#medica').is(":checked");
                    if(a){
                        $(".medica").removeClass('active');
                        this.cancleSelected(value)
                    }else {
                        $(".label_box .medica").addClass('active');
                        $('.selectedBox').append(`<div class="cancle medica" >
                            <div class="canclebox medica"><label for="medica"><img src="https://www.thingjs.com/guide/static/images/close.png" class="close-icon"></label></div>
                            <div class="label_box medicadown" style="margin-right:0px;">智慧医疗</div>
                            </div>`);
                        $('.cancle.medica').on('mouseenter',function (){
                            $('.canclebox.medica').css('display','inline-block');
                            $('.label_box.medicadown').css('background-color','#ffb53e');
                            $('.label_box.medicadown').css('color','#fff');
                        })
                        $('.cancle.medica').on('mouseleave',function (){
                            $('.canclebox.medica').css('display','none');
                            $('.label_box.medicadown').css('background-color','rgb(255, 158, 0)');
                            $('.label_box.medicadown').css('color', '#fff');
                        })
                        $('.cancle.medica .canclebox').on('click',function (){
                            $(".label_box .medica").trigger("click");
                        })
                        $('.cancle').css({'display':'inline-block'});
                    }
                    break;
                case 'water':
                    a=$('#water').is(":checked");
                    if(a){
                        $(".water").removeClass('active');
                        this.cancleSelected(value)
                    }else {
                        $(".label_box .water").addClass('active');
                         $('.selectedBox').append(`<div class="cancle water" >
                            <div class="canclebox water"><label for="water"><img src="https://www.thingjs.com/guide/static/images/close.png" class="close-icon"></label></div>
                            <div class="label_box waterdown" style="margin-right:0px;">智慧水利</div>
                            </div>`);
                        $('.cancle.water').on('mouseenter',function (){
                            $('.canclebox.water').css('display','inline-block');
                            $('.label_box.waterdown').css('background-color','#ffb53e');
                            $('.label_box.waterdown').css('color','#fff');
                        })
                        $('.cancle.water').on('mouseleave',function (){
                            $('.canclebox.water').css('display','none');
                            $('.label_box.waterdown').css('background-color','rgb(255, 158, 0)');
                            $('.label_box.waterdown').css('color', '#fff');
                        })
                        $('.cancle.water .canclebox').on('click',function (){
                            $(".label_box .water").trigger("click");
                        })
                        $('.cancle').css({'display':'inline-block'});
                    }
                    break;
                case 'traffic':
                    a=$('#traffic').is(":checked");
                    if(a){
                        $(".traffic").removeClass('active');
                        this.cancleSelected(value)
                    }else {
                        $(".label_box .traffic").addClass('active');
                        $('.selectedBox').append(`<div class="cancle traffic" >
                            <div class="canclebox traffic"><label for="traffic"><img src="https://www.thingjs.com/guide/static/images/close.png" class="close-icon"></label></div>
                            <div class="label_box trafficdown" style="margin-right:0px;">智慧交通</div>
                            </div>`);
                        $('.cancle.traffic').on('mouseenter',function (){
                            $('.canclebox.traffic').css('display','inline-block');
                            $('.label_box.trafficdown').css('background-color','#ffb53e');
                            $('.label_box.trafficdown').css('color','#fff');
                        })
                        $('.cancle.traffic').on('mouseleave',function (){
                            $('.canclebox.traffic').css('display','none');
                            $('.label_box.trafficdown').css('background-color','rgb(255, 158, 0)');
                            $('.label_box.trafficdown').css('color', '#fff');
                        })
                        $('.cancle.traffic .canclebox').on('click',function (){
                            $(".label_box .traffic").trigger("click");
                        })
                        $('.cancle').css({'display':'inline-block'});
                    }
                    break;

            }
        },
         chooseproduct(value,iscancle) {
            let a;
            let b = 0;
            switch (value) {
                case 'visualization':
                    a=$('#visualization').is(":checked");
                    if(a){
                        $(".visualization").removeClass('active');
                        this.cancleSelected(value)
                    }else {
                        $(".label_box .visualization").addClass('active');
                         $('.selectedBox').append(`<div class="cancle visualization" >
                            <div class="canclebox visualization"><label for="visualization"><img src="https://www.thingjs.com/guide/static/images/close.png" class="close-icon"></label></div>
                            <div class="label_box visualizationdown" style="margin-right:0px;">数据可视化</div>
                            </div>`);
                        $('.cancle.visualization').on('mouseenter',function (){
                            $('.canclebox.visualization').css('display','inline-block');
                            $('.label_box.visualizationdown').css('background-color','#ffb53e');
                            $('.label_box.visualizationdown').css('color','#fff');
                        })
                        $('.cancle.visualization').on('mouseleave',function (){
                            $('.canclebox.visualization').css('display','none');
                            $('.label_box.visualizationdown').css('background-color','rgb(255, 158, 0)');
                            $('.label_box.visualizationdown').css('color', '#fff');
                        })
                        $('.cancle.visualization .canclebox').on('click',function (){
                            $(".label_box .visualization").trigger("click");
                        })
                        $('.cancle').css({'display':'inline-block'});
                    }
                    break;
                case 'Web':
                    a=$('#Web').is(":checked");
                    if(a){
                        $(".Web").removeClass('active');
                        this.isClose = false;
                        this.cancleSelected(value)
                    }else {
                        $(".label_box .Web").addClass('active');
                        $('.selectedBox').append(`<div class="cancle Web" >
                            <div class="canclebox Web"><label for="Web"><img src="https://www.thingjs.com/guide/static/images/close.png" class="close-icon"></label></div>
                            <div class="label_box Webdown" style="margin-right:0px;">Web组态</div>
                            </div>`);
                        $('.cancle.Web').on('mouseenter',function (){
                            $('.canclebox.Web').css('display','inline-block');
                            $('.label_box.Webdown').css('background-color','#ffb53e');
                            $('.label_box.Webdown').css('color','#fff');
                        })
                        $('.cancle.Web').on('mouseleave',function (){
                            $('.canclebox.Web').css('display','none');
                            $('.label_box.Webdown').css('background-color','rgb(255, 158, 0)');
                            $('.label_box.Webdown').css('color', '#fff');
                        })
                        $('.cancle.Web .canclebox').on('click',function (){
                            $(".label_box .Web").trigger("click");
                        })
                        $('.cancle').css({'display':'inline-block'});
                    }
                    break;
                case 'threecity':
                    a=$('#threecity').is(":checked");
                    if(a){
                        $(".threecity").removeClass('active');
                        this.isClose = false;
                        this.cancleSelected(value)
                    }else {
                        $(".label_box .threecity").addClass('active');
                         $('.selectedBox').append(`<div class="cancle threecity" >
                            <div class="canclebox threecity"><label for="threecity"><img src="https://www.thingjs.com/guide/static/images/close.png" class="close-icon"></label></div>
                            <div class="label_box threecitydown" style="margin-right:0px;">三维城市</div>
                            </div>`);
                        $('.cancle.threecity').on('mouseenter',function (){
                            $('.canclebox.threecity').css('display','inline-block');
                            $('.label_box.threecitydown').css('background-color','#ffb53e');
                            $('.label_box.threecitydown').css('color','#fff');
                        })
                        $('.cancle.threecity').on('mouseleave',function (){
                            $('.canclebox.threecity').css('display','none');
                            $('.label_box.threecitydown').css('background-color','rgb(255, 158, 0)');
                            $('.label_box.threecitydown').css('color', '#fff');
                        })
                        $('.cancle.threecity .canclebox').on('click',function (){
                            $(".label_box .threecity").trigger("click");
                        })
                        $('.cancle').css({'display':'inline-block'});
                    }
                    break;
                case 'threecamps':
                    a=$('#threecamps').is(":checked");
                    if(a){
                        $(".threecamps").removeClass('active');
                        this.isClose = false;
                        this.cancleSelected(value)
                    }else {
                        $(".label_box .threecamps").addClass('active');
                        $('.selectedBox').append(`<div class="cancle threecamps" >
                            <div class="canclebox threecamps"><label for="threecamps"><img src="https://www.thingjs.com/guide/static/images/close.png" class="close-icon"></label></div>
                            <div class="label_box threecampsdown" style="margin-right:0px;">三维园区</div>
                            </div>`);
                        $('.cancle.threecamps').on('mouseenter',function (){
                            $('.canclebox.threecamps').css('display','inline-block');
                            $('.label_box.threecampsdown').css('background-color','#ffb53e');
                            $('.label_box.threecampsdown').css('color','#fff');
                        })
                        $('.cancle.threecamps').on('mouseleave',function (){
                            $('.canclebox.threecamps').css('display','none');
                            $('.label_box.threecampsdown').css('background-color','rgb(255, 158, 0)');
                            $('.label_box.threecampsdown').css('color', '#fff');
                        })
                        $('.cancle.threecamps .canclebox').on('click',function (){
                            $(".label_box .threecamps").trigger("click");
                        })
                        $('.cancle').css({'display':'inline-block'});
                    }
                    break;
                case 'integration':
                    a=$('#integration').is(":checked");
                    if(a){
                        $(".integration").removeClass('active');
                        this.cancleSelected(value)
                    }else {
                        $(".label_box .integration").addClass('active');
                        $('.selectedBox').append(`<div class="cancle integration" >
                            <div class="canclebox integration"><label for="integration"><img src="https://www.thingjs.com/guide/static/images/close.png" class="close-icon"></label></div>
                            <div class="label_box integrationdown" style="margin-right:0px;">数据集成</div>
                            </div>`);
                        $('.cancle.integration').on('mouseenter',function (){
                            $('.canclebox.integration').css('display','inline-block');
                            $('.label_box.integrationdown').css('background-color','#ffb53e');
                            $('.label_box.integrationdown').css('color','#fff');
                        })
                        $('.cancle.integration').on('mouseleave',function (){
                            $('.canclebox.integration').css('display','none');
                            $('.label_box.integrationdown').css('background-color','rgb(255, 158, 0)');
                            $('.label_box.integrationdown').css('color', '#fff');
                        })
                        $('.cancle.integration .canclebox').on('click',function (){
                            $(".label_box .integration").trigger("click");
                        })
                        $('.cancle').css({'display':'inline-block'});
                    }
                    break;

            }
        },
        cancleSelected(value,list,iscancle){
            if(value == 'lowcode') {
                value = 'low';
            }else if(value == 'zerocode') {
                value = 'zero'
            }
            $('.cancle.'+value).remove();
        },
        checkNever() {
            if(!this.noMoreExtend) {
                $('.checkBoxLast').addClass('active');
            }else {
                $('.checkBoxLast').removeClass('active');
            }
            this.noMoreExtend =!this.noMoreExtend;
        },
        showClose(name) {
            debugger
            $(name).css('display','none');
        },
        hideClose(name) {
            debugger
            $(name).css('display','block');
        },
        nextStep() {
            this.isPop = false;
            this.noPass = true;
            let a = 0;
            let b = 0;
            let c = 0;
            let codestring = '';
            let scenestring = '';
            let productstring = '';
            let that = this;
            if(this.noMoreExtend) {
                this.noMoreExtend = this.noMoreExtend+0;
            }else {
                this.noMoreExtend = this.noMoreExtend+0;
            }
            $('.sel_box').css({'height':'100%'});
            for(a;a<this.checkCode.length;a++) {
                codestring += this.checkCode[a] + ',';
            }
            for(b;b<this.checkScene.length;b++) {
                scenestring += this.checkScene[b] + ',';
            }
            for(c;c<this.checkProduct.length;c++) {
                productstring += this.checkProduct[c] + ',';
            }
            codestring =  codestring.slice(0,codestring.length-1) ;
            scenestring =  scenestring.slice(0,scenestring.length-1) ;
            productstring =  productstring.slice(0,productstring.length-1) ;
            let newMoreNeeds =  this.moreneeds ;
            // console.log(this.checkCode,this.checkScene,this.checkProduct);
            // return
            // if(!codestring) {
            //     layer.msg("至少选择一个选择开发形式");
            //     return
            // }else if(!scenestring) {
            //     layer.msg("至少选择一个智慧场景");
            //     return
            // } else if(!productstring) {
            //     layer.msg("至少选择一个意向产品");
            //     return
            // } else {
                // url:window.location.protocol+'//test-thingjs.3dlink.cn/api/chooseInterests',
            if(this.isMmdidLegitimate) {
                $.ajax({
                    url:window.location.protocol+'//test-thingjs.3dlink.cn/api/chooseInterests',
                    type:'post',
                    data:{
                        token:$.cookie('token'),
                        userId:this.mmdId,
                        company_extend_1:JSON.stringify(codestring),
                        company_extend_2:JSON.stringify(scenestring),
                        company_extend_3:JSON.stringify(productstring),
                        company_extend_4:JSON.stringify(newMoreNeeds),
                        noMoreExtend:this.noMoreExtend
                    },
                    success:function(res) {
                        // if(res.state == 0){
                            that.isLastPage = true;
                            that.selSuccessPanel=true;
                            that.isLast = true;
                            that.noCompany = true;
                            that.registerSuccess();
                        // }
                    }
                })
            }

            // }
            if(!this.isOldPage) {
                this.closeSelBox()
            }
            if(self!=top) {
                window.parent.postMessage({
                    type:"changeStyle",
                    height:"457px",
                    width:"800px"
                } ,'*');
                $('body, html').css({'background':'rgba(0,0,0,0)'});
            }
        }
    },
    mounted(){
        this.mmdId = this.$route.query.userId;
        this.referee='';
        var _this = this;
        try{
            this.isMmdidLegitimate = this.$global.AntiSqlValid(this.mmdId);
        }catch(e){
            this.isMmdidLegitimate = true;
        }
        if(self == top){
            this.currentUrl = window.location.href
        }
        if(this.mmdId) {
            var id=this.getUserName('id');
            if(self!=top) {
                $.ajax({
                    url:window.location.protocol+'//www.thingjs.com/api/getUserForPaas/user_info?mmdid='+this.mmdId,
                    type:'get',
                    success:function(res) {
                        if(res&&res.state) {
                            _this.setCookie('id',res.id);
                        }
                    }
                })
            }
        }
        window.addEventListener("message", function(event) {
           if(self!=top) {
               if(document.referrer&&(document.referrer.indexOf('studio.thingjs.com')!=-1||document.referrer.indexOf('studio.uino.com')!=-1)) _this.showStep=false;
               $('#app').css("background","none");
               $('.model_service_box').css("background","rgba(0,0,0,0)");
               $('body').css("background","rgba(0,0,0,0)");
               if(document.referrer&&document.referrer.indexOf('www.thingjs.com')==-1&&document.referrer.indexOf('store.thingjs.com')==-1&&document.referrer.indexOf('store.thingjs.com')==-1)  _this.showStep=false;
           }
            if(event.data == "fixed"){
                 $('.model_service_container').css({
                    'top':'0','left':'0','transform':'none'
                 })
            }
            if(event.data.openCampanyPanel){// 来自thingjs
                var result = {infos:event.data.openCampanyPanel};
                _this.from = result.infos.type;
                if(result.infos.type == "companyServerFirst"){
                    var token=result.infos.token||'',accessToken=result.infos.accessToken||'';
                    if(token.length) {_this.token=token;_this.setCookie("token",token);}
                    if(accessToken.length) {_this.accessToken=accessToken;_this.setCookie("accessToken",accessToken);}
                    _this.pages = result.infos.msg.pages?result.infos.msg.pages.split("."):[];
                    if(!token.length) {
                        if(!(document.referrer&&document.referrer.indexOf('www.thingjs.com')==-1&&document.referrer.indexOf('store.thingjs.com')==-1&&document.referrer.indexOf('store.thingjs.com')==-1))  {
                             _this.pages.push('setPwd');
                        };
                    }
                    _this.openPage = _this.pages[0];
                    _this.stepALL = _this.pages.length;
                }else{
                    _this.pages = result.infos.msg.pages.split(".");
                    _this.openPage = _this.pages[0];
                    _this.stepALL = _this.pages.length+1;
                }
                if(_this.from == "document" || _this.from == "view") _this.stepALL = _this.pages.length;
                _this.getinfosItem(result);
            }
        })
        var _this = this;
        bus.$on("openCampanyPanel",(data) =>{//打开留资
        _this.selSuccessPanel=false;
            if(data.infos.type == "companyServerFirst"){
                _this.pages = data.infos.msg.pages?data.infos.msg.pages.split("."):[];
                _this.pages.push('setPwd');
                _this.openPage = _this.pages[0];
                // _this.openPage = 'setPwd';
                _this.stepALL = _this.pages.length;
            }else{
                // 只缺手机号，只缺三项，都缺
                _this.pages = data.infos.msg.pages.split(".");
                _this.openPage = _this.pages[0];
                _this.stepALL = _this.pages.length+1;
            }
            if(data.infos.type == "view") _this.stepALL = _this.pages.length;
            _this.getinfosItem(data);

        });
    },
    filters: {
        hightStr(value,keyWord){
            keyWord=keyWord.toUpperCase();
            var p=``;
            var m=pinyinMatch.match(value,keyWord);
            if(keyWord.length&&value.length&&m) {
                var keyscord=value.substring(m[0],m[1]+1);
                var reg = new RegExp(keyscord,"g");
                p = value.toUpperCase().replace(reg,'<span class="active">'+keyscord+'</span>');
                return `<p>`+p+`</p>`
            } else {
                p = value;
                return `<p>`+p+`</p>`
            }
        }
    }
}
</script>
<style lang="">
@import '../assets/css/companyInfo.css';
</style>



// WEBPACK FOOTER //
// src/components/CampanyInfoNew.vue